import * as types from "../types";
import advisorhq from "../../apis/advisorhq";

export const fetchNotifications = filters => async (dispatch, getState) => {
  dispatch({ type: types.LOADING, payload: { notifications: true } });
  const response = await advisorhq.get("/life_settlement/api/notifications/", {
    params: { ...filters },
  });
  dispatch({ type: types.FETCH_NOTIFICATIONS, payload: response.data });
  dispatch({ type: types.LOADING, payload: { notifications: false } });
};
